import * as Styled from '../../policy.styled';

function TermsOfServiceKo() {
  return (
    <Styled.MainWrapper>
      <h3>제1장 총칙</h3>
      <p>제1조 목적</p>본 약관은 주식회사 버블탭 (이하 “회사”라 합니다)이 제공하는 팅글 (Tingle), 리워드 (Reward), 등
      모든 서비스(이하 “서비스”라 합니다)의 이용과 관련하여 이용자의 권리, 의무 및 책임사항 등을 규정함을 목적으로
      합니다.
      <br />
      <br />
      회사가 제공하는 서비스를 사용함으로, 이용자(제2조 용어의 정의 참조)는 이용약관 및 회사가 정하는 정책에 동의 및
      수락하는 것으로 간주합니다.
      <p>제2조 용어의 정의</p>
      <ol>
        ① 본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
        <li> “이용자”라 함은 회사가 제공하는 서비스를 이용하는 회원과 비회원을 말합니다.</li>
        <li> “회원”이라 함은 본 약관 및 개인정보 제공에 동의하고, 서비스 이용 자격을 부여받은 대상자를 의미합니다.</li>
        <li>
          “콘텐츠”라 함은 회사가 제공하는 서비스와 관련되어 게시 또는 제공한, 그리고 생성된 내용물 일체를 의미합니다.
          여기에는 인공지능(이하 AI)을 사용하여 제작 또는 생성한 캐릭터, 서사, 테마, 문서, 텍스트, 대화, 사진, 정보,
          이미지, 비디오, 음성 노트, 음악, 디자인, 알고리즘, 프롬프트 등 (묶어서 “애셋”), 모두 포함되어 있습니다.
        </li>
        <li>“입력 메시지”라 함은 이용자가 회사의 팅글 서비스를 이용하고 애셋들을 활용하기 위한 텍스트를 의미합니다.</li>
        <li>“출력 메시지”라 함은 이용자의 입력 메시지를 기반하여 팅글 서비스가 출력한 텍스트를 의미합니다.</li>
        <li> “유료서비스”라 함은 “회사”가 유료로 제공하는 콘텐츠 및 제반 서비스를 의미합니다.</li>
        <li>
          “접근기기”라 함은 PC, 휴대폰, 태블릿 등을 의미하며, 이에 한정되지 아니하고 향후 개발되는 콘텐츠 등 정보 접근의
          도구로 사용되는 여하한 형태의 하드웨어, 기기 등의 유형물을 의미합니다.
        </li>
        <li>
          “게시물”이라 함은 회원이 서비스를 이용함에 있어 서비스에 게시한 부호, 텍스트, 문자, 이미지, 음성, 음향, 화상,
          동영상 등의 정보 형태의 글, 그림, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다. 이용자가 AI 콘텐츠를
          회사의 플랫폼에 제작 또는 생성하기 위한 프롬프트, 소개글, 설명, 이미지, 소개문구, 등을 포함합니다.
        </li>
        <li>
          “내부 재화"라 함은 회원이 회사가 제공하는 앱이나 플랫폼 내에서 획득, 구매 또는 받을 수 있는 가상의 화폐
          형태입니다.
        </li>
        <li>“내부 재화”는 앱 내에서 회사가 제공하는 유료 서비스와 교환할 수 있는 수단입니다.</li>② 본 약관에서 사용하는
        용어의 정의는 본 조 제1항 각호에서 정하는 것을 제외하고는 개별 이용약관, 서비스 가이드, 관계 법령, 기타 일반
        상관례에 의합니다.
      </ol>
      <p>제3조 신원정보 등의 제공</p>
      회사는 개인정보 처리방침, 상호, 대표자 성명, 주소, 전화번호·전자우편주소, 사업자등록번호, 통신판매업 신고번호,
      고객센터 등을 회원이 쉽게 알 수 있도록 서비스 초기화면에 게시합니다.
      <p>제4조 약관의 게시와 개정</p>
      <ol>
        ① 회사는 이 약관의 내용을 회원이 쉽게 알 수 있도록 서비스 초기화면 내 또는 별도의 연결화면에 게시하거나 팝업화면
        등으로 제공합니다. <br /> <br /> ② 회사는 정보통신망이용촉진및정보보호등에관한법률,
        전자상거래등에서의소비자보호에관한법률, 약관의규제에관한법률 등 관련 법을 위반하지 않는 범위에서 이 약관을
        개정할 수 있습니다.
        <br /> <br /> ③ 회사는 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행 약관과 함께 제1항의 방식에
        따라 그 개정약관의 적용일자 7일 전부터 적용일자 전일까지 공지합니다. 다만, 회원에게 불리한 약관 개정의 경우에는
        적용일자 30일 전에 공지하고, 회원이 이용 시 제공한 제공한 전자우편, 서비스 내 팝업 화면 등의 등의 전자적 수단을
        통해 따로 명확히 통지하도록 합니다.
        <br /> <br />
        ④ 회사는 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 7일 또는 30일 기간 내에 거부의 의사표시를 하지
        않으면 약관 개정에 동의한 것으로 간주한다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의
        의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.
        <br /> <br /> ⑤ 회원이 개정약관의 적용에 동의하지 않는 경우 회사는 개정약관의 내용을 적용할 수 없으며, 이 경우
        회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 회사는
        이용계약을 해지할 수 있습니다.
      </ol>
      <p>제5조 약관의 해석</p>
      ① 회사는 이 약관 외에 별도의 이용약관 및 정책(이하 “개별약관 등”)을 둘 수 있으며, 해당 내용이 이 약관과 상충할
      경우에는 개별약관 등이 우선하여 적용됩니다. <br />
      <br />
      ② 이 약관에서 정하지 아니한 사항이나 해석에 대해서는 개별약관 등 및 관계 법령 또는 상관례에 따릅니다. <br />
      <br />③ 회사가 저작권자 등 콘텐츠 제공자로부터 이용 또는 사용을 허락 받아 회원의 이용에 제공하는 유료 서비스에
      대해서는 콘텐츠 제공자의 국적 국가의 법 및 조약이 적용될 수 있습니다.
      <p>제6조 이용계약 등 체결</p>
      <ol>
        ① 이용계약은 이용자가 회사가 제공하는 서비스를 사용함으로 체결됩니다. 또한 이용계약은 회원이 되고자 하는 자(이하
        “가입신청자”)가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고, 회사가 이러한 신청에 대하여
        승낙함으로써 체결됩니다.
        <br /> <br />
        ② 회사는 가입신청자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 14세 미만 아동이
        법정대리인(부모 등)의 동의를 얻지 아니하거나, 이용자의 귀책사유로 인하여 승인이 불가능한 경우, 실명이 아니거나
        타인의 명의를 이용한 경우, 회사 회원 자격을 상실하는 경우, 기타 이 약관의 제반 사항을 위반한 경우 등에 해당하는
        신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.
        <br /> <br />
        ③ 제1항에 따른 신청에 있어 회사는 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.
        <br /> <br />
        ④ 회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는 업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
        <br /> <br />
        ⑤ 제2항과 제4항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 회사는 원칙적으로 이를 가입신청자에게
        알립니다.
        <br /> <br />
        ⑥ 이용계약의 성립 시기는 회사가 가입완료를 신청절차 상에서 표시한 시점으로 정하고, 유료서비스 이용계약의 경우는
        구매완료를 신청절차 상에서 표시한 시점으로 정합니다.
        <br /> <br />
        ⑦ 회사는 회원에 대해 회사 정책에 따라 등급별로 구분하여 이용시간, 이용횟수, 서비스 메뉴 등을 세분하여 이용에
        차등을 둘 수 있습니다.
        <br /> <br />
        ⑧ 회사는 회원에 대하여 청소년보호법, 영화및비디오물의진흥에관한법률 등에 따른 등급 및 연령 준수를 위해
        이용제한이나 등급별 제한을 할 수 있고, 성인인증 절차를 거치도록 할 수 있습니다.
        <br /> <br />
        ⑨ 회원이 유료서비스를 이용하기 위해서는 이 약관 및 해당 유료서비스에 대한 개별약관등에 동의 후 유료서비스의
        이용조건에 따라 이용요금을 지급하여야 합니다.
        <br /> <br />
        ⑩ 회사는 만 19세 미만의 미성년 회원이 유료서비스를 이용하고자 하는 경우에 부모 등 법정대리인의 동의를 얻거나,
        계약체결 후 추인을 얻지 않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는 내용을 계약체결 전에
        고지하는 조치를 취합니다.
        <br />
      </ol>
      <p>제7조 회원정보의 변경</p>
      <ol>
        ① 회원은 본 약관에 의하여 회사에 정보를 제공하여야 하는 경우에는 진실된 정보를 제공하여야 하며, 허위정보
        제공으로 발생한 불이익에 대해서는 보호받지 못합니다.
        <br />
        <br />
        ② 회원은 회원가입신청 시 기재한 사항이 변경되었을 경우 온라인으로 수정을 하거나 전자우편 기타 방법으로 회사에
        대하여 그 변경사항을 알려야 합니다.
        <br />
        <br />
        ③ 전항의 변경사항을 회사에 알리지 않아 발생하는 회원 및 기타 제3자의 불이익에 대하여 회사는 책임지지 않습니다.
        <br />
      </ol>
      <p>제8조 개인정보보호 의무</p>
      회사는 개인정보보호법 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다. 개인정보의 보호
      및 사용에 대해서는 관련법 및 회사의 개인정보 처리방침이 적용됩니다. 다만, 회사의 공식 사이트 이외의 링크된
      사이트에서는 회사의 개인정보 처리방침이 적용되지 않습니다.
      <p>제9조 회원의 아이디 및 비밀번호의 관리에 대한 의무</p>
      <ol>
        ① 회원의 아이디와 비밀번호에 관한 관리책임은 회원에게 있으며, 이를 제3자가 이용하도록 하여서는 안 됩니다. 회원은
        아이디 하에서 발생하는 모든 활동에 대한 책임이 있습니다.
        <br />
        <br />
        ② 회사는 회원의 아이디가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 회사 관계자 및
        서비스의 운영자로 오인될 우려가 있는 경우, 직접 해당 아이디의 이용을 제한할 수 있습니다.
        <br />
        <br />
        ③ 회원은 아이디 및 비밀번호가 도용되거나 제3자가 사용하고 있음을 인지한 경우에는 이를 즉시 회사에 통지하고
        회사의 안내에 따라야 합니다.
        <br />
        <br />④ 제3항의 경우에 해당 회원이 회사에 그 사실을 통지하지 않거나, 통지한 경우에도 회사의 안내에 따르지 않아
        발생한 불이익에 대하여 회사는 책임지지 않습니다.
        <br />
        <br />⑤ 이용약관 또는 회사의 정책에 위반한 것으로 의심되는 경우, 회사가 회원의 아이디를 종료하거나 제한할 수
        있습니다.
      </ol>
      <p>제10조 회원에 대한 통지</p>
      <ol>
        ① 회사가 회원에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소, 전자쪽지, 로그인 시
        팝업화면 등으로 할 수 있습니다.
        <br />
        <br />② 회사는 회원 전체에 대한 통지의 경우 7일 이상 서비스 내 게시판, 팝업 화면 등에 게시함으로써 전항의 통지에
        갈음할 수 있습니다. 다만, 회원 본인의 거래와 관련하여 중대한 영향을 미치는 사항에 대하여는 전항의 통지를 합니다.
      </ol>
      <p>제11조 회사의 의무</p>
      <ol>
        ① 회사는 관련법과 이 약관 및 개별약관등이 금지하거나 미풍양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로
        서비스를 제공하기 위하여 최선을 다하여 노력합니다.
        <br />
        <br />
        ② 회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며
        개인정보 처리방침을 공시하고 준수합니다.
        <br />
        <br />
        ③ 회사는 서비스 이용과 관련하여 발생하는 이용자의 불만 또는 피해구제요청을 적절하게 처리할 수 있도록 필요한 인력
        및 시스템을 구비합니다.
        <br />
        <br />④ 회사는 서비스 이용과 관련하여 회원으로부터 제기된 의견이나 불만이 정당하다고 인정할 경우에는 이를
        처리하여야 합니다. 회원이 제기한 의견이나 불만사항에 대해서는 게시판을 활용하거나 전자우편 등을 통하여 회원에게
        처리과정 및 결과를 전달합니다.
        <br />
        <br />⑤ 회사는 회원 또는 이용자의 불법적 또는 회사가 금지하는 행위에 의해 발생하는 어떠한 피해나 손상에 대해
        책임 지지 않습니다.
      </ol>
      <p>제12조 회원의 의무</p>
      <ol>
        ① 회원은 다음 행위를 하여서는 안 됩니다.
        <li> 신청 또는 변경 시, 허위 내용의 등록</li>
        <li> 타인의 정보도용</li>
        <li> 회사가 게시한 정보의 수정, 변경, 번역, 또는 적용</li>
        <li> 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시</li>
        <li> 회사 서비스를 구성하는 프롬프트, 소프트웨어, 또는 자료의 소스 코드를 재구성</li>
        <li> 회사 서비스의 보안 기능이나 사용 제한을 우회하거나 방해</li>
        <li> 회사 또는 제3자의 데이터, 시스템, 또는 네트워크에 무단 접근, 손상, 비활성화, 방해, 과부하</li>
        <li> 회사 또는 제3자에게 실질적 피해 또는 손상 또는 손해를 초래할 수 있는 행위</li>
        <li> 회사와 기타 제3자의 저작권 등 지적재산권에 대한 침해</li>
        <li> 회사 및 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위</li>
        <li> 외설 또는 폭력적인 메시지, 화상, 음성, 기타 공서양속에 반하는 정보를 서비스에 공개 또는 게시하는 행위</li>
        <li> 회사의 동의 없이 영리를 목적으로 서비스를 사용하는 행위</li>
        <li> 회원 계정을 본인 외 제3자로 하여금 이용하도록 하는 행위</li>
        <li> 회사 및 회원이 속해 있는 국가의 법률에 위배되는 행위</li>
        <li> 기타 불법적이거나 부당한 행위</li>
        <br /> ② 회원 및 이용자는 텍스트 메시지, 음성 메시지, 이미지, 비디오, 애셋 등을 통해 생성한 콘텐츠 및 게시물에
        대해 전적으로 책임집니다. 회원 및 이용자는 회사의 서비스를 사용하며 생성된 AI의 출력물에 대해 전적으로
        책임집니다. 회원 및 이용자는 회사의 AI 서비스 사용에 있어 이용약관, 회사 정책, 및 관련 법을 준수할 것에 동의하며
        회사가 금지한 또는 불법 행위에 의해 발생하는 모든 책임을 집니다.
        <br />
        <br /> ③ 회원 또는 이용자는 회사의 AI 서비스를 이용함으로 해당 서비스에서 생성되는 출력 텍스트, 문서, 이미지,
        영상, 음성, 음악, 디자인 등이 AI의 생성물임을 인지하는 것으로 간주합니다. 회사는 회사의 AI 서비스에 의해 생성된
        결과물, 콘텐츠, 또는 애셋의 정확성 또는 사실 유무를 보장하지 않습니다.
        <br />
        <br /> ④ 회원은 관계법, 이 약관 및 운영정책, 개별약관등의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항,
        회사가 통지하는 사항, 청소년보호법 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안 됩니다.
        회사는 이를 미준수하는 회원 또는 이용자의 계정을 정지 또는 종료할 수 있습니다. 계정 정지 또는 종료시 해당 회원
        또는 이용자의 게시물 또는 콘텐츠를 제거할 수 있습니다.
      </ol>
      <p>제13조 유료서비스의 내용 등의 표시</p>
      <ol>
        ① 회사는 다음 사항을 해당 유료서비스의 이용초기화면이나 FAQ 등에 회원이 알기 쉽게 표시합니다.
        <li>유료서비스의 명칭 또는 제호</li>
        <li>유료서비스 주체의 성명(법인인 경우는 법인의 명칭), 주소, 전화번호</li>
        <li>유료서비스의 내용, 이용방법, 이용료, 기타 이용조건</li>
        <br />
        ② 회사의 유료서비스의 이용가능기기 및 이용에 필요한 최소한의 기술사항은 권장사양정보에 따릅니다.
        <br />
        <br />
        ③ 회사는 유료서비스를 제공함에 있어 유료서비스의 교환·반품·보증과 그 대금 환불의 조건 및 절차에 관한 사항을
        제공합니다. 이용약관 제19조 참조.
        <br />
        <br />④ 회사가 제공하는 유료 서비스의 이용권 또는 상품권 등은 회사 외 제3자(회사의 계열회사 포함)를 통해 판매될
        수 있으며 해당 판매 상품의 이용 방식, 청약철회 및 환불 등은 각 제휴사가 제공하는 유료서비스 이용약관 및 정책에
        따릅니다.
      </ol>
      <p>제14조 서비스의 제공, 중단 및 변경</p>
      <ol>
        ① 회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한
        경우에는 그 내용을 사전에 공지합니다.
        <br />
        <br />
        ② 서비스는 연중무휴, 1일 24시간 제공됨을 원칙으로 합니다.
        <br />
        <br />
        ③ 회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 서비스의
        제공을 일시적으로 중단할 수 있습니다. 이 경우 회사는 이 약관에서 정한 방법으로 회원에게 통지합니다. 다만, 회사가
        사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.
        <br />
        <br />
        ④ 회사는 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에
        따릅니다.
        <br />
        <br />
        ⑤ 사업종목의 전환, 사업의 포기, 분할·합병 등의 이유로 유료서비스를 제공할 수 없게 되는 경우에는 이 약관에서 정한
        방법으로 회원에게 통지하고 당초 제시한 조건에 따라 회원에게 보상합니다.
        <br />
        <br />⑥ 회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부의 서비스를
        변경할 수 있고, 해당 서비스 초기 화면에 관련 사항을 게시합니다. 다만, 유료서비스를 변경하는 경우로서 변경된
        내용이 중대하거나 회원에게 불리한 경우에는 이 약관에서 정한 방법으로 통지하고, 필요한 경우 이 약관에서 정한 바에
        따라 회원에게 보상합니다.
      </ol>
      <p>제15조 정보의 제공 및 광고의 게재</p>
      <ol>
        ① 회사는 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편 등의 방법으로 회원에게
        제공할 수 있습니다. 다만, 회원은 관련법에 따른 거래관련 정보 및 고객문의 등에 대한 답변 등을 제외하고는 언제든지
        전자우편 등에 대해서 수신을 거부할 수 있습니다. <br />
        <br />② 제1항의 정보를 전자적 전송매체에 의하여 전송하려고 하는 경우에는 회원의 사전 동의를 받아서 전송합니다.
        다만, 회원의 거래관련 정보 및 고객문의 등에 대한 회신은 사전 동의 없이 전송합니다.
        <br />
        <br />③ 이용자가 회사가 서비스하는 콘텐츠 및 회사의 원활한 서비스 이용을 위한 업데이트 알림을 신청하는 경우
        회사는 전자우편, SMS, 앱 푸쉬(App Push), 전자쪽지 등 전자적 전송매체를 통해 이용자에게 정보를 제공(이하
        “업데이트 알림”)합니다.
        <br />
        <br /> ④ 업데이트 알림의 내용은 회사의 서비스 정책에 따라 변경, 제거 또는 추가될 수 있습니다.
        <br />
        <br />
        ⑤ 이용자는 언제든지 설정화면에서 변경을 통해 업데이트 알림 기능을 해제할 수 있습니다. 이 경우 회사는 이용자에게
        업데이트 알림을 보내지 않습니다.
        <br />
        <br />
        ⑥ 회사는 서비스 화면, 홈페이지 등에 직접, 주식회사 버블탭 또는 제휴 관계에 있는 제3자를 통해 광고를 게재할 수
        있습니다.
        <br />
        <br />
        ⑦ 회사는 회원이 사전 동의한 경우에 한하여 전자우편, SMS, 앱 푸쉬(App Push), 전자쪽지 등 전자적 전송매체를 통해
        광고성 정보를 발송할 수 있습니다. 광고성 정보를 수신한 회원은 원하지 않는 경우에 언제든지 수신을 거부할 수
        있으며, 회사는 회원의 수신 거부시 광고성 정보를 발송하지 않습니다.
        <br />
        <br />⑧ 회원은 회사가 제공하는 서비스와 관련하여 게시물 또는 기타 정보를 변경, 수정, 제한하는 등의 조치를 취하지
        않습니다.
      </ol>
      <p>제16조 게시물의 저작권</p>
      <ol>
        ① 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 저작자에게 귀속됩니다. 회원은 회원의 게시물 및 입력
        메시지와 관련하여 회사에게 이용약관에 따라 사용권 또는 라이센스를 제공합니다. 해당 사용권은 저작권의 이전을
        의미하지 않습니다. 회원의 게시물에 대한 저작권의 범주에는 해당 게시물의 제작 또는 생성을 위해 회사가 회원에게
        제공한 기술, 도구, 소프트웨어, 플랫폼 디자인, 출력 메시지 등이 포함되어 있지 않습니다. 회사의 명시적 허가 없이
        회사의 지적재산권을 복제, 수정, 배포, 사용, 등을 할 수 없습니다.
        <br />
        <br />
        ② 이용자 또는 회원은 회사의 플랫폼에 게시물을 등록함으로써 회사에게 해당 게시물에 대한 제한적 사용권을
        허용합니다. 이용자 또는 회원이 회사의 서비스를 이용함으로써 회사에게 부여하는 사용권은 비독점적입니다. 해당
        사용권은 회사에 의해 비독점적으로 양도 또는 서브 라이선스 가능하며 2차 저작물 생성, 모델 연구개발 및 학습, 등
        다양한 상업적 용도로 사용 될 수 있습니다. 이용자 또는 회원이 서비스 내에 게시하는 게시물은 회사의 현재 및 미래
        서비스, 새로운 매체 또는 언어로의 전환 등 회사 서비스의 확장을 위한 마케팅, 홍보, 및 프로모션 등에 노출(해당
        노출을 위해 필요한 범위 내에서의 일부 수정, 복제, 편집 포함)될 수 있습니다. 또한 이용자 또는 회원의 게시물은
        회사, 콘텐츠 및 서비스의 개선과 새로운 콘텐츠 및 서비스 제공을 위한 연구개발 목적으로 활용될 수 있습니다.
        <br />
        <br />
        ③ 이용자 또는 회원은 회사의 서비스를 사용하면서 회사의 AI 서비스에 의해 생성된 콘텐츠(출력 메세지, 텍스트,
        이미지, 음성, 음악, 배경음악, 동영상, 등)에 대한 저작권을 관련 국가 법령이 정하는 바에 따라 가집니다. 이용자
        또는 회원은 회사의 서비스를 이용함으로써 회사에게 생성 콘텐츠에 대한 비독점적, 제한적 사용권을 허용합니다. 해당
        사용권은 회사에 의해 비독점적으로 양도 또는 서브 라이선스 가능하면 2차 저작물 생성, 모델 연구개발 및 학습, 등
        다양한 상업적 용도로 사용 될 수 있습니다. 이용자 또는 회원이 회사의 서비스를 사용함으로써 생성되는 콘텐츠는
        회사의 현재 및 미래 서비스, 새로운 매체 또는 언어로의 전환 등 회사 서비스의 확장을 위한 마케팅, 홍보, 및
        프로모션 등에 노출(해당 노출을 위해 필요한 범위 내에서의 일부 수정, 복제, 편집 포함)될 수 있습니다. 또한 이용자
        또는 회원의 생성된 콘텐츠는 회사, 콘텐츠 및 서비스의 개선과 새로운 콘텐츠 및 서비스 제공을 위한 연구개발
        목적으로 활용될 수 있습니다.
        <br />
        <br />④ 이용자 또는 회원이 본인의 게시물을 회사의 서비스에서 삭제 또는 비공개 처리를 하더라도 회사에게 제공한
        제한적 사용권(②항 참조)은 유지됩니다.
        <br />
        <br />⑤ 회사가 제2항 이외의 방법으로 회원의 게시물을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해
        사전에 회원의 동의를 얻어야 합니다.
        <br />
        <br />⑥ 회원은 회사의 서비스를 이용함으로 회원의 모든 게시물 및 입력 메시지에 대한 권리, 권한, 라이선스, 또는
        저작권을 보유하고 있음을 회사에게 보증합니다.
      </ol>
      <p>제17조 게시물의 관리</p>
      <ol>
        ① 회원의 게시물에 정보통신망이용촉진및정보보호등에관한법률, 저작권법 등 관련법에 위반되는 내용이 포함된 경우,
        권리자는 관련법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 회사는 관련법에 따라
        조치를 취하여야 합니다.
        <br />
        <br />
        ② 회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및
        관련법에 위반되는 경우에는 관련법에 따라 해당 게시물에 대해 임시조치 등을 취할 수 있습니다. 따라서 회사는 회원
        또는 이용자의 콘텐츠 또는 게시물을 검열 및 삭제할 수 있습니다. 또한 회사는 내부 판단에 따라 해당 회원 또는
        이용자의 계정을 정지 또는 삭제할 수 있습니다.
        <br />
        <br />③ 본 조에 따른 세부절차는 정보통신망이용촉진및정보보호등에관한법률, 저작권법이 규정한 범위 내에서 회사가
        정한 게시중단요청서비스에 따릅니다.
      </ol>
      <p>제18조 권리의 귀속</p>
      <ol>
        ① 서비스에 대한 저작권 및 지식재산권은 회사에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물
        등은 제외합니다.
        <br />
        <br />② 회사는 서비스와 관련하여 회원에게 회사가 정한 이용조건에 따라 계정, 아이디, 정보, 결제수단 등을 이용할
        수 있는 이용권만을 부여하며, 회원은 회사가 허용하지 않는 한 이를 양도, 판매, 담보제공 등의 방법으로 처분하여서는
        아니됩니다.
      </ol>
      <p>제19조 지급방법 및 환불</p>
      <ol>
        ① 회원은 다음 각 호의 방법으로 유료서비스를 이용할 수 있으며, 회사는 서비스 운영 상의 이유나 콘텐츠 제공자와의
        계약 등으로 인해 일부 콘텐츠에 대해서는 그 중 일부 방법만을 결제 수단으로 제공할 수 있습니다. 단, 회원이 선택한
        결제수단 제공자가 별도로 존재하는 경우, 회원은 해당 결제수단을 이용하기 전에 해당 결제수단에서 요구되는 절차를
        이행하여야 해당 결제수단을 이용하여 결제를 진행할 수 있으며, 해당 결제수단을 이용한 결제에 관해서는 회원이 해당
        결제수단의 제공자와 사이에 체결한 계약조건이 적용됩니다.
        <li> 앱마켓(구글플레이) 인앱결제</li>
        <li> 앱마켓(앱스토어) 인앱결제</li>
        <li> 토스 페이먼츠 주식회사 웹 결제</li>
        <li> 그 밖에 회사가 정한 결제수단</li>
        <br />② 회사의 정책 및 제1항의 결제방법 제공자가 정한 기준에 따라 회원의 월별 누적 결제액 및 유료서비스
        구매한도가 제한될 수 있습니다. 해당 기준을 초과한 경우 유료서비스의 추가 이용은 불가능할 수 있습니다. 회원이
        회사의 내부 재화를 카드 결제시 카드사가 결제 금액을 일정 금액 이하로 제한하거나 결제가 불가할 수 있습니다.
        <br />
        <br />③ 구매한 회사의 내부 재화는 회원간 양도가 불가능합니다.
        <br />
        <br />④ 회사 내부 재화의 유효기간은 다음과 같습니다.
        <ol>
          <li> 구매한 회사의 내부 재화를 사용할 수 있는 기한은 최대 1년입니다.</li>
          <li> 무료로 회원에게 지급된 회사의 무료 내부 재화를 사용할 수 있는 기한은 최대 1년이내입니다.</li>
        </ol>
        ⑤ 결제 취소 및 환불
        <ol>
          <li> 회사의 내부 재화를 구매한 이후 환불은 내부 재화를 구입하기 위해 사용한 결제 수단으로 진행됩니다.</li>
          <li> 회사의 내부 재화 환불 요청할 수 있는 기한은 내부 재화 구입 시점에서부터 7일 내입니다. </li>
          <li>
            {' '}
            회사와 구매에 관한 계약을 체결한 회원은 아래와 같이 결제 에 대한 취소 및 환불을 요구할 수 있습니다.
            <ol>
              <li style={{ listStyleType: 'lower-alpha' }}>
                회사의 내부 재화를 구매한 후, 해당 내부 재화 패키지의 유료 내부 재화 또는 무료로 지급된 내부 재화의
                일부를 사용한 이후 미사용한 포인트에 대해 결제 취소 및 환불을 진행할 수 없습니다. 즉, 구입한 회사의 내부
                재화 패키지에 대한 부분 환불은 불가능합니다.
              </li>
              <li style={{ listStyleType: 'lower-alpha' }}>
                회사의 내부 재화 패키지를 구입한 이후 해당 패키지에 포함된 유료 내부 재화 및 무료 내부 재화를 사용하지
                않았으면 해당 패키지 구매 시점에 결제된 금액에 따라 취소 및 환불됩니다.
              </li>
            </ol>
          </li>
          <li>
            {' '}
            회사의 귀책사유로 결제 오류가 발생한 경우, 결제에 대한 취소 및 환불을 요구할 수 있습니다. 본 이용약관의
            제23조를 참조하세요.
          </li>
          <li>
            {' '}
            회사의 귀책사유로 서비스가 중단되는 경우, 결제에 대한 취소 및 환불을 요구할 수 있습니다. 본 이용약관의
            제14조를 참조하세요.
          </li>
        </ol>
      </ol>
      <p>제20조 회원의 청약 철회등, 계약해지 및 회원 탈퇴</p>
      <ol>
        ① 회원은 언제든지 서비스초기화면의 고객센터 또는 내 정보 관리 메뉴 등을 통하여 이용계약 해지 신청 또는 회원
        탈퇴를 할 수 있으며, 회사는 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.
        <br />
        <br />
        ② 회원이 계약을 해지 또는 회원 탈퇴할 경우 관련법 및 개인정보 처리방침에 따라 회사는 회원정보를 보유하여야 하는
        경우를 제외하고는 해지 즉시 회원의 모든 정보는 소멸됩니다.
        <br />
        <br />
        ③ 회원이 계약을 해지 또는 회원탈퇴하는 경우 회원이 작성한 게시물 중 본인 계정에 등록된 게시물은 삭제되지 않을 수
        있습니다. 특히 회원이 생성한 AI 캐릭터, 서사, 테마 등은 삭제되지 않습니다. 제3자에 의해 담기, 스크랩 등이 되어
        재게시되거나, 공용게시판에 등록된 게시물은 삭제되지 않으니 사전에 삭제 후 탈퇴하시기 바랍니다.
        <br />
        <br />④ 유료서비스 이용계약을 체결 또는 회사의 내부재화를 구입한 회원은 회사의 내부 정책 및 관련 법령에서 정한
        바에 따라 일정기간 내에 청약을 철회하거나 해당 계약을 해제(이하 “청약철회등”)할 수 있습니다. 단, 다음 각 호의
        경우에는 청약철회등이 제한됩니다.
        <ol>
          <li>
            회원이 회사 내부재화를 유료 구매한 이후 해당 내부재화의 환불 어뷰징(서비스 운영정책 제6조 참조)을 하는
            것으로 회사가 판단하였을 경우
          </li>
          <li>
            회원이 회사 내부재화를 유료 구매한 이후 해당 내부재화의 유료 또는 무료분 일부를 소진한 이후 내부재화 잔액에
            대해 청약철회 또는 환불 시도할 경우
          </li>
          <li>회원이 회사가 지급한 무료 내부재화에 대해 청약철최 또는 환불 시도할 경우</li>
          <li>
            회원에게 책임이 있는 사유로 재화등이 멸실되거나 훼손된 경우. 다만, 재화등의 내용을 확인하기 위하여 포장 등을
            훼손한 경우
          </li>
          <li> 회원의 사용 또는 일부 소비로 재화등의 가치가 현저히 감소한 경우</li>
          <li> 시간이 지나 다시 판매하기 곤란할 정도로 재화등의 가치가 현저히 감소한 경우</li>
          <li>
            복제가 가능한 재화등의 포장을 훼손한 경우는 문화산업진흥기본법 제2조 제5호의 디지털콘텐츠의 제공이 개시된
            경우. 다만, 가분적 용역 또는 가분적 디지털콘텐츠로 구성된 계약의 경우에는 제공이 개시되지 아니한 부분에
            대하여는 그러하지 아니하다.
          </li>
          <li>
            회원의 주문에 따라 개별적으로 생산되는 재화등 또는 이와 유사한 재화등에 대하여 청약철회등을 인정하는 경우
            주식회사 버블탭에게 회복할 수 없는 중대한 피해가 예상되는 경우로서 사전에 해당 거래에 대하여 별도로 그
            사실을 고지하고 회원의 서면(전자문서 포함)에 의한 동의를 받은 경우
          </li>
        </ol>
        ⑤ 회원은 전항에도 불구하고 회사의 유료서비스의 내용이 표시·광고의 내용과 다르거나 계약내용과 다르게 이행된
        경우에는 그 재화등을 공급받은 날부터 3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날부터 30일 이내에
        청약철회등을 할 수 있습니다.
        <br />
        <br />⑥ 회원은 다음 각 호의 경우 유료서비스 이용계약을 해지 또는 해제할 수 있습니다.
        <ol>
          <li> 유료서비스의 하자가 보완, 수정될 수 없는 경우 유료서비스를 공급받은 날로부터 1개월 이내</li>
          <li> 회원이 이 약관 변경에 동의하지 않아 회원탈퇴 또는 유료서비스 이용계약을 해지하는 경우</li>
        </ol>
        ⑦ 제1항 및 제2항에 따른 회사와 회원의 반품·교환·환불·취소 관련 사항은 제21조에서 정한 바에 따릅니다.
      </ol>
      <p>제21조 청약철회등 및 계약해지의 효과</p>
      <ol>
        ① 회사는 회원이 청약철회등, 계약해지의 의사표시를 한 날부터 3영업일 이내에 환불 결정을 회원에게 통보해야 하며
        환불 결정 후 3영업일 이내에 대금의 결제와 동일한 방법으로 이를 환불하여야 하며, 동일한 방법으로 환불이 불가능할
        때에는 이를 사전에 고지하여야 합니다. 다만, 수납확인이 필요한 결제수단의 경우에는 수납확인일부터 3영업일 이내에
        이를 환불하도록 할 수 있습니다.
        <br /> <br />
        ② 회원의 청약철회등 및 계약해지는 이용약관 제19조 및 제20조에 의해 제한될 수 있습니다.
        <br /> <br />
        ③ 회사가 환불 시 회원이 신용카드 또는 전자결제수단 등의 결제수단으로 재화등의 대금을 지급한 때에는 지체없이 당해
        결제수단을 제공한 사업자로 하여금 재화등의 대금의 청구를 정지 또는 취소하도록 요청합니다. 다만, 제1항 단서 및
        제2항의 경우는 그러하지 아니할 수 있습니다.
        <br /> <br />
        ④ 회사 유료서비스의 대금을 받은 자 또는 회원과 유료서비스 이용계약을 체결한 자가 동일인이 아닌 경우에 각자는
        청약철회등과 관련한 의무의 이행에 있어서 연대하여 책임을 집니다.
        <br /> <br />⑤ 회사는 앱마켓 결제(인앱결제) 및 웹 결제에 있어 해당 앱마켓 및 웹 결제사에 대하여 대금지급의
        정지∙취소 요청 등 전자상거래등에서의소비자보호에관한법률에 따른 관련 조치를 취합니다. 다만, 위와 같은 회사의
        요청에 따른 해당 앱마켓의 조치에 관하여는 해당 앱마켓의 정책을 참조하여 주시기 바랍니다.
      </ol>
      <p>제22조 회사의 계약해제, 해지 및 이용제한 등</p>
      <ol>
        ① 회사는 회원이 이 약관, 개별약관등을 위반하거나 서비스의 정상적인 운영을 방해하는 것이 합리적으로 의심되거나
        밝혀진 경우 경고, 일시정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다. 다만, 이러한 이용
        제한에도 불구하고 더 이상 서비스 이용계약의 온전한 유지를 기대하기 어려운 경우에는 부득이하게 이용 제한 조치에
        더해 회원과의 이용계약을 해제 또는 해지 할 수 있습니다.
        <br /> <br />
        ② 회사는 회원이 계속해서 3개월 이상 로그인하지 않는 경우 회원정보의 보호 및 운영의 효율성을 위해 직접 서비스
        이용을 제한할 수 있습니다.
        <br /> <br />
        ③ 제1항, 제2항과 관련하여 서비스 이용을 통해 획득한 회원의 무상 혜택은 소멸되고, 회사는 이에 대해 별도로
        보상하지 않습니다. 단, 회원의 귀책사유로 인하여 회사가 이용계약을 해제 또는 해지하는 경우, 회원의 요청에 따라
        유료서비스 대금을 환불하되, 회원의 ID가 도용되었거나 ID가 콘텐츠의 무단 복제·배포 등을 포함한 기타 불법적인
        행위에 이용되는 등 특별한 사정이 있는 경우에는 환불 또는 보상을 하지 않습니다.
        <br /> <br />
        ④ 회사는 제3항 단서에 따라 환불이 필요한 경우 제22조 제1항을 준용하되, 회원이 유료서비스 이용으로부터 얻은 이익
        및 환불수수료(10% 또는 1,000원 중 큰 금액)에 해당하는 금액을 환불할 금액에서 공제할 수 있습니다.
        <br /> <br />
        ⑤ 제1항의 해제, 해지는 회사가 이 약관에서 정한 통지방법에 따라 회원에게 그 의사를 표시한 때에 효력이 발생합니다.
        <br /> <br />⑥ 회사의 해제, 해지 및 이용제한에 대하여 회원은 회사가 정한 절차에 따라 이의신청을 할 수 있습니다.
        이때 이의가 정당하다고 인정되는 경우 회사는 즉시 서비스의 이용을 재개합니다.
      </ol>
      <p>제23조 과오금</p>
      <ol>
        ① 회사는 과오금이 발생한 경우 회원이 결제한 방법과 동일한 방법으로 환불하며, 동일한 방법으로 환불이 불가능할
        때에는 이를 사전에 고지합니다.
        <br /> <br />
        ② 회사의 책임이 있는 사유로 과오금이 발생한 경우에는 과오금 전액을 환불하며, 회원의 책임이 있는 사유로 과오금이
        발생한 경우, 회사는 과오금을 환불하는데 소요되는 비용은 합리적인 범위 내에서 회원이 부담하여야 합니다.
        <br /> <br />③ 회사는 과오금의 환불절차를 콘텐츠이용자보호지침에 따라 처리 합니다.
      </ol>
      <p>제24조 사용기간 등</p>
      <ol>
        ① 유료서비스의 사용기간 또는 유효기간은 사전에 별도로 표시되지 않는 한 거래일로부터 1년입니다. 해당 기간이
        경과한 유료서비스는 이용권한이 소멸되며 보유목록에서 삭제될 수 있습니다.
        <br /> <br />② 단, 위브 플러스 30일권의 경우 보너스 포인트 사용기한은 결제일 포함 30일로 합니다.
      </ol>
      <p>제25조 재화등의 하자에 의한 피해보상</p>
      유료서비스의 하자 등에 의한 회원 피해보상은 콘텐츠이용자보호지침에서 정한 바에 따릅니다.
      <p>제26조 책임제한</p>
      <ol>
        ① 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한
        책임이 면제됩니다.
        <br /> <br />
        ② 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.
        <br /> <br />
        ③ 회사는 회원이 서비스와 관련하여 게재한 그리고 회사의 AI 서비스를 통해 생성된 정보, 자료, 결과값의 신뢰도,
        정확성, 적법성, 독창성, 배타성, 진실성, 활용 가능성, 적합성을 보장하지 않으며 관련 내용에 따른 회원 또는
        이용자의 행위에 책임을 지지 않습니다.
        <br /> <br />
        ④ 회사의 AI 서비스의 정보, 자료, 결과값의 이용과 관련하여 발생하는 모든 문제에 대한 책임은 회원에게 있으며,
        회사는 이에 대하여 일체의 책임을 지지 아니합니다.
        <br />
        <br />
        ⑤ 회사는 회원 또는 이용자가 게시판에 게재한 또는 회사의 서비스를 사용하며 게시한 정보, 자료, 내용 등에 관하여
        사실의 정확성, 신뢰도 등에 어떠한 책임을 지지 않으며 회원은 본인의 책임 아래 서비스를 이용해야 합니다.
        <br />
        <br />
        ⑥ 회사는 회원 또는 이용자가 서비스 이용과 관련하여 회원에게 발생한 손해 중 회원의 고의, 과실에 의한 손해 및 타
        회원으로 인해 입게 되는 정신적 피해에 대하여 보상할 책임을 지지 않습니다.
        <br />
        <br />
        ⑦ 회사는 회원 간 또는 회원과 제3자 상호간에 회사의 서비스를 매개로 하여 소통, 통신, 연락, 교제, 거래 등을 한
        경우에는 발생한 어떠한 피해 또는 손실에 책임이 면제됩니다.
        <br /> <br />⑧ 회사는 서비스 이용과 관련하여 관련법이 없는 한 책임을 지지 않습니다.
        <br />
        <br />⑨ 회원은 본 이용약관을 위반하여 상대방에게 손해를 입힌 경우에는 그 손해를 배상할 책임이 있습니다. 다만,
        고의 또는 과실이 없는 경우에는 그러하지 아니 합니다.
        <br />
        <br />⑩ 회원이 게시 또는 전송한 자료 등에 관하여 손해가 발생하거나 자료의 취사선택과 관련해 어떠한 불이익이
        발생하더라도 이에 대한 모든 책임은 회원에게 있습니다.
        <br />
        <br />⑪ 회사 또는 회원은 본 약관을 위반하여 상대방에게 손해를 입힌 경우에는 그 손해를 배상할 책임이 있습니다.
        다만, 고의 또는 과실이 없는 경우에는 그러하지 아니 합니다.
      </ol>
      <p>제27조 준거법 및 재판관할</p>
      <ol>
        ① 회사와 회원 간 제기된 소송은 대한민국법을 준거법으로 합니다.
        <br /> <br />
        ② 회사와 회원 간 발생한 분쟁에 관한 소송은 제소 당시의 회원의 주소에 의하고, 주소가 없는 경우 거소를 관할하는
        지방법원의 전속관할로 합니다. 단, 제소 당시 회원의 주소 또는 거소가 명확하지 아니한 경우의 관할법원은
        민사소송법에 따라 정합니다.
        <br /> <br />③ 해외에 주소나 거소가 있는 회원의 경우 회사와 회원 간 발생한 분쟁에 관한 소송은 전항에도 불구하고
        대한민국 서울중앙지방법원을 관할법원으로 합니다.
      </ol>
      {/* <p>[부칙] 이 약관은 2022년 8월 xx일부터 적용됩니다.</p> */}
    </Styled.MainWrapper>
  );
}

export default TermsOfServiceKo;
